//left in for ajax / anything else that
//is using jquery
var $body = $('.js-body');

const body = document.querySelector(".js-body"),
    tickers = document.querySelectorAll(".js-ticker"),
    fullheight = document.querySelector(".js-full-height");
    //   thisPage = body.dataset.page,
    //site = body.dataset.site

let width = window.innerWidth,
    height = window.innerHeight,
    screenOrientation,
    dragging = false;

    if ((width / height) > 1) {
        screenOrientation = 'landscape';
    } else {
        screenOrientation = 'portrait';
    }
